/**
 * <ui-option value disabled>: an option in a <ui-select>. Its content is the
 * page's own markup, which the select slots into its list, so page CSS and
 * utilities style it (./options.css has the defaults). value defaults to the
 * text, as a native option's does.
 *
 * The select marks the selected option with data-selected and the
 * highlighted one with data-highlighted. data-selected and disabled set the
 * option's ARIA state here.
 */
export class UiOption extends HTMLElement {
  static observedAttributes = [ "disabled", "data-selected" ]

  #internals = this.attachInternals()

  constructor() {
    super()
    this.#internals.role = "option"
  }

  attributeChangedCallback() {
    this.#internals.ariaDisabled = ariaTrue(this.disabled)
    this.#internals.ariaSelected = ariaTrue(this.hasAttribute("data-selected"))
  }

  get value() {
    return this.getAttribute("value") ?? this.label
  }

  get label() {
    return this.textContent.replace(/\s+/g, " ").trim()
  }

  get disabled() {
    return this.hasAttribute("disabled")
  }
}

function ariaTrue(condition) {
  if (condition) return "true"

  return null
}

customElements.define("ui-option", UiOption)
